export default class CookieConsent {
  static _loadAllowed () {
    const allowedTypes = (localStorage.getItem('vol_cookie_consent_allowed') || '').split(',')

    for (const allowedType of allowedTypes) {
      document.querySelectorAll(`[data-load-when-allowed="${allowedType}"]`).forEach(element => {
        element.src = element.getAttribute('data-src')
      })
    }
  }

  static _handleAccept (all = false) {
    const acceptedTypes = Array
      .from(document.querySelectorAll(`input[id^="cookie-consent-"]${all ? '' : ':checked'}`))
      .map(input => input.id.replace('cookie-consent-', ''))

    localStorage.setItem('vol_cookie_consent_allowed', acceptedTypes.join(','))

    document.getElementById('cookie-consent-dialog').classList.add('hidden')
    document.body.classList.remove('fade')

    CookieConsent._loadAllowed()
  }

  static _registerEvents () {
    document.getElementById('accept-all-cookies').addEventListener('click', () => CookieConsent._handleAccept(true))
    document.getElementById('accept-selected-cookies').addEventListener('click', () => CookieConsent._handleAccept())
  }

  static init () {

    let node = document.querySelector("p.privacy-protocol");

    console.log("INIT NODE");
    console.log(node);

    if (node != null) {
      let desc = document.querySelector("#cookie-description");
      if (desc != null) {
        node.appendChild(desc);
        desc.style.display = "block";
      }
      //let cookieCode ='TEST<script id="CookieDeclaration" src="https://consent.cookiebot.com/5abb9f83-9e53-49c4-bbdf-5e72ced2ede9/cd.js" type="text/javascript" async></script>';
      //iframe.srcdoc = '<!DOCTYPE html><html><body>' + cookieCode + '</body></html>';
      //node.appendChild(iframe);
    }

    //if (localStorage.getItem('vol_cookie_consent_allowed')) {
      //CookieConsent._loadAllowed()

      //return
    //}

    //const { href } = window.location
    //const dialog = document.getElementById('cookie-consent-dialog')

    //if (dialog && !href.includes('/impressum') && !href.includes('/datenschutz')) {
      //dialog.classList.remove('hidden')
      //document.body.classList.add('fade')
    //}

    //CookieConsent._registerEvents()
  }
}
